
export function convertToLocalTime (utcDateString) {
    if (!utcDateString) return ("N/A");
    const date = new Date(utcDateString + " UTC");
    if (isNaN(date.getTime())) return ("Invalid Date");
    return new Intl.DateTimeFormat(navigator.language, {
        year: '2-digit',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
    }).format(date);
};